export default __webpack_public_path__ + "dist/media/FolderSkyBg.97234725.svg";